import { searchCSForList } from "../model/carsubs";

export const setFilter = (filter) => {
	return {
		type: "SET_FILTER_CS",
		payload: filter,
	};
};

export const searchCSList = (filter) => {
	return {
		type: "SEARCH_CS_LIST",
		payload: searchCSForList(filter),
	};
};

export const searchCSListMore = (filter) => {
	return {
		type: "SEARCH_CS_LIST_MORE",
		payload: searchCSForList(filter),
	};
};
